/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PdfAnnotation } from './PdfAnnotation';
import {
    PdfAnnotationFromJSON,
    PdfAnnotationFromJSONTyped,
    PdfAnnotationToJSON,
    PdfAnnotationToJSONTyped,
} from './PdfAnnotation';
import type { SignaturePlacement } from './SignaturePlacement';
import {
    SignaturePlacementFromJSON,
    SignaturePlacementFromJSONTyped,
    SignaturePlacementToJSON,
    SignaturePlacementToJSONTyped,
} from './SignaturePlacement';

/**
 * 
 * @export
 * @interface SubmitFormDocumentRequest
 */
export interface SubmitFormDocumentRequest {
    /**
     * Text annotations to add to the PDF. Matches the FieldPlacement max of 200 so a template with up to 200 required text_input fields can always be submitted.
     * @type {Array<PdfAnnotation>}
     * @memberof SubmitFormDocumentRequest
     */
    annotations?: Array<PdfAnnotation>;
    /**
     * Signature images with positions from FieldPlacement type=signature. Required only for forms that contain a signature field; text-only forms may omit this.
     * @type {Array<SignaturePlacement>}
     * @memberof SubmitFormDocumentRequest
     */
    signaturePlacements?: Array<SignaturePlacement>;
}

/**
 * Check if a given object implements the SubmitFormDocumentRequest interface.
 */
export function instanceOfSubmitFormDocumentRequest(value: object): value is SubmitFormDocumentRequest {
    return true;
}

export function SubmitFormDocumentRequestFromJSON(json: any): SubmitFormDocumentRequest {
    return SubmitFormDocumentRequestFromJSONTyped(json, false);
}

export function SubmitFormDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitFormDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'annotations': json['annotations'] == null ? undefined : ((json['annotations'] as Array<any>).map(PdfAnnotationFromJSON)),
        'signaturePlacements': json['signaturePlacements'] == null ? undefined : ((json['signaturePlacements'] as Array<any>).map(SignaturePlacementFromJSON)),
    };
}

export function SubmitFormDocumentRequestToJSON(json: any): SubmitFormDocumentRequest {
    return SubmitFormDocumentRequestToJSONTyped(json, false);
}

export function SubmitFormDocumentRequestToJSONTyped(value?: SubmitFormDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'annotations': value['annotations'] == null ? undefined : ((value['annotations'] as Array<any>).map(PdfAnnotationToJSON)),
        'signaturePlacements': value['signaturePlacements'] == null ? undefined : ((value['signaturePlacements'] as Array<any>).map(SignaturePlacementToJSON)),
    };
}

